// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  ModelVersionStatus,
} from "./types";


export default __t.row({
  versionId: __t.u64().primaryKey().name("version_id"),
  dtmi: __t.string(),
  version: __t.string(),
  get status() {
    return ModelVersionStatus;
  },
  createdDateTime: __t.timestamp().name("created_date_time"),
});
